import { EInsideTAInfrastructureType, EOutsideTAInfrastructureType, TTAInfrastructureType } from '../../types/map';
import { ITAInfrastructure } from '../../types/map/transportAccessibilityService/transportAccessibilityInfrastructure';

export const POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES = Object.values(EOutsideTAInfrastructureType);
export const POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES = Object.values(EInsideTAInfrastructureType);

export const OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP: Record<
  EOutsideTAInfrastructureType,
  // TODO: Заменить на тип респонса в CD-170031.
  keyof ITAInfrastructure['outside']
> = {
  [EOutsideTAInfrastructureType.busStops]: 'busStops',
  [EOutsideTAInfrastructureType.tramStops]: 'tramStops',
  [EOutsideTAInfrastructureType.metro]: 'metro',
  [EOutsideTAInfrastructureType.parking]: 'parking',
  [EOutsideTAInfrastructureType.bikeParking]: 'bikeParking',
  [EOutsideTAInfrastructureType.chargingStations]: 'chargingStations',
  [EOutsideTAInfrastructureType.scooterParking]: 'scooterParking',
  [EOutsideTAInfrastructureType.boulevards]: 'boulevards',
};

export const INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP: Record<
  EInsideTAInfrastructureType,
  keyof ITAInfrastructure['inside']
> = {
  // TODO: Заменить на тип респонса в CD-170031.
  [EInsideTAInfrastructureType.yardWithoutCars]: 'yardWithoutCars',
  [EInsideTAInfrastructureType.parking]: 'parking',
  [EInsideTAInfrastructureType.placeOfShortTransportStop]: 'placeOfShortTransportStop',
  [EInsideTAInfrastructureType.bikeParking]: 'bikeParking',
  [EInsideTAInfrastructureType.chargingStations]: 'chargingStations',
  [EInsideTAInfrastructureType.scooterParking]: 'scooterParking',
  [EInsideTAInfrastructureType.boulevards]: 'boulevards',
  [EInsideTAInfrastructureType.trafficSafetyElements]: 'trafficSafetyElements',
};

export const INFRASTRUCTURE_TYPE_TO_TITLE_MAP: Record<TTAInfrastructureType, string> = {
  [EOutsideTAInfrastructureType.busStops]: 'Автобусная остановка',
  [EOutsideTAInfrastructureType.tramStops]: 'Трамвайная остановка',
  [EOutsideTAInfrastructureType.metro]: 'Метро',
  [EOutsideTAInfrastructureType.parking]: 'Парковка',
  [EOutsideTAInfrastructureType.bikeParking]: 'Велопарковка',
  [EOutsideTAInfrastructureType.chargingStations]: 'Станция зарядки электромобилей',
  [EOutsideTAInfrastructureType.scooterParking]: 'Парковка для самокатов',
  [EOutsideTAInfrastructureType.boulevards]: 'Пешеходный бульвар',

  [EInsideTAInfrastructureType.yardWithoutCars]: 'Двор без машин',
  [EInsideTAInfrastructureType.parking]: 'Парковка',
  [EInsideTAInfrastructureType.placeOfShortTransportStop]: 'Место для короткой остановки транспорта',
  [EInsideTAInfrastructureType.bikeParking]: 'Велопарковка',
  [EInsideTAInfrastructureType.chargingStations]: 'Станция зарядки электромобилей',
  [EInsideTAInfrastructureType.scooterParking]: 'Парковка для самокатов',
  [EInsideTAInfrastructureType.boulevards]: 'Пешеходный бульвар',
  [EInsideTAInfrastructureType.trafficSafetyElements]: 'Элемент безопасности движения',
};
